module.exports = __webpack_public_path__ + "files/7c27f7f4698f1155907ab938b86df66e.png";